import { useEffect, useState } from "react";
import { Button } from "antd";
import { getCookie } from "../util/utils";
import "./CookieNotification.scss";

export default function CookieNotification() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getCookie("cookiesAccepted") !== "true") {
      setVisible(true);
    }
  }, []);

  function hide() {
    setVisible(false);
    const now = new Date();
    now.setTime(now.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expiration = "expires=" + now.toUTCString();
    document.cookie = "cookiesAccepted=true;" + expiration + ";path=/";
  }

  return !visible ? null : (
    <div className={"cookie-notification"}>
      <div className={"close"} onClick={hide}>
        &times;
      </div>
      We use cookies. By continuing, you agree to their usage.
      <br />
      See <a href="/feature/cookie-policy.html">Cookie Policy</a>
      <Button onClick={hide}>Agree</Button>
    </div>
  );
}
